//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueUeditorWrap from 'vue-ueditor-wrap';
import fileUploader from '../../../views/common-components/file-uploader';
import SelectProjectModal from '../components/select-project-modal';

export default {
    name: 'progressEdit',
    components: {
        SelectProjectModal,
        VueUeditorWrap,
        fileUploader
    },
    data() {
        return {
            loading: false,
            id: 0,
            current: 0,
            currentStyle0: {
                display: 'block'
            },
            currentStyle1: {
                display: 'none'
            },
            progressInfo: {
                file: { associateType: 'ProjectProgress' }
            },
            rules: {
                projectName: [{ required: true, message: '请选择项目', trigger: 'blur' }],
                uploader: [{ required: true, message: '不能为空', trigger: 'blur' }],
                month: [{ required: true, message: '请选择月份', trigger: 'change' }],
                year: [{ required: true, message: '请选择年份', trigger: 'change' }],
                contentType: [{ required: true, type: 'number', message: '请选择类别', trigger: 'change' }],
                source: [{ required: true, message: '链接不能为空', trigger: 'blur' }]
            },
            saving: false,
            editorConfig: {
                UEDITOR_HOME_URL: '/UEditor/'
            },
            fUeditor: null,
            finance: {
                content: ''
            },
            ueditor: null,
            showAddProjectModal: false,
            months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
            years: []
        };
    },
    methods: {
        showCurrent(current) {
            if (current === 0) {
                this.currentStyle0.display = 'block';
                this.currentStyle1.display = 'none';
            }
            if (current === 1) {
                this.currentStyle0.display = 'none';
                this.currentStyle1.display = 'block';
            }

        },
        fEditorReady(editor) {
            this.ueditor = editor;
            this.finance = {
                content: ''
            };
        },
        showAddProject() {
            this.showAddProjectModal = true;
        },
        addProject(data) {
            // console.log(data);
            const vm = this;
            vm.progressInfo.projectId = data.id;
            vm.progressInfo.projectName = data.name;
            vm.showAddProjectModal = false;
        },
        onBack() {
            this.current = 0;
            this.showCurrent(0);
            this.getProgressInfo();
        },
        onSaveInfo() {

            this.finance.content = this.progressInfo.content;
            const vm = this;
            this.$refs.progressInfoForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    console.log('activity:' + vm.activity);
                    console.log('val:' + val);

                    vm.$store.dispatch({
                        type: 'progress/saveProjectProgress',
                        data: vm.progressInfo
                    }).then(() => {

                        vm.$Notice.success({
                            duration: 3,
                            title: '保存成功'
                        });
                        vm.id = vm.$store.state.progress.progressId;
                        if (vm.progressInfo.contentType == 1) {
                            this.$router.push({ path: '/progressDetail/' + vm.id });
                        } else {
                            vm.current = 1;
                            vm.showCurrent(vm.current);
                        }
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        getProgressInfo() {
            if (this.id <= 0) {
                return;
            }
            var vm = this;
            vm.loading = true;
            vm.$store.dispatch({
                type: 'progress/GetProjectProgressById',
                id: vm.id
            }).then(() => {
                vm.progressInfo = this.$store.state.progress.progressInfo;
                vm.progressInfo.file = { associateType: 'ProjectProgress' };
                vm.finance.content = vm.progressInfo.content;
            }).finally(() => {
                vm.loading = false;
            });
        },
        onProgressContent() {
            var vm = this;
            vm.finance.id = this.id;
            vm.saving = true;
            abp.ajax.post('/api/services/app/ProjectProgress/SaveProgressContent', vm.finance).then(() => {
                // vm.$router.push({ path: '/project/progresses' });
                this.$router.push({ path: '/progressDetail/' + vm.id });
            }).finally(() => {
                vm.saving = false;
            });
        }

    },
    created() {
        this.id = parseInt(this.$route.params.id);
        this.getProgressInfo();
        var y = new Date().getFullYear();
        this.years = [];
        for (let j = 5; j > 0; j--) {
            this.years.push((y - j).toString());
        }
        for (let i = 0; i < 6; i++) {
            this.years.push((y + i).toString());
        }
    }
};
